module.exports = __webpack_public_path__ + "static/media/star-small-grey.3b52892c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/star-small-grey.svg
// module id = 1044
// module chunks = 0